export function NameValidation(name) {
    if (name.length < 3) {
        return false;
    } else {
        return true;
    }
};
